import { render, staticRenderFns } from "./ProtocolModal.vue?vue&type=template&id=04cf1f8a&scoped=true&"
import script from "./ProtocolModal.vue?vue&type=script&lang=js&"
export * from "./ProtocolModal.vue?vue&type=script&lang=js&"
import style0 from "./ProtocolModal.vue?vue&type=style&index=0&id=04cf1f8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04cf1f8a",
  null
  
)

export default component.exports